import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions as CanvasActions } from '~app/features/canvas';
import { useT } from '~app/core/BundleProvider';
import withEnterToClick from '~app/core/withEnterToClick';
import lodash from 'lodash';
import { actions as DocumentActions } from '~app/features/document';

const ClickOrEnterDiv = withEnterToClick('div');

// Self check button in the workspace
const CheckButton = () => {
  const t = useT();
  const editMode = useSelector(state => state.document.present?.editMode);
  const hasSolution = useSelector(
    state => !lodash.isEmpty(state.document.present?.solutionModel?.nodes),
  );
  //only show check button when in student mode (not solution/creation mode) and when a non-empty solution object exists
  const showCheckButton = editMode !== 'solution' && hasSolution;
  const dispatch = useDispatch();
  const isInCompareMode = useSelector(
    state => state.canvas?.compareWithSolution ?? false,
  );

  const checkAgainstSolution = () => {
    if (!isInCompareMode) {
      dispatch(CanvasActions.enterComparisonState());
    }
    dispatch(DocumentActions.tabulateErrors());
  };

  return (
    showCheckButton && (
      <ClickOrEnterDiv
        className={`Check__button ${
          isInCompareMode ? 'Check__button-activated' : ''
        }`}
        role="button"
        tabIndex="0"
        aria-current={isInCompareMode ? 'true' : 'false'}
        onClick={checkAgainstSolution}
        aria-label={t('open-check')}
      >
        {t('check')}
        {isInCompareMode && <span className="visually-hidden">current</span>}
      </ClickOrEnterDiv>
    )
  );
};

export default CheckButton;
